const mutations = {
  setActiveCampaigns(state, payload) {
    state.activeCampaigns = payload;
  },

  setExpiredCampaigns(state, payload) {
    state.expiredCampaigns = payload;
  },

  setCampaign(state, payload) {
    state.campaign = payload;
  },

  setChannelData(state, payload) {
    state.channelData = payload;
  },

  setCategories(state, payload) {
    state.categories = payload;
  },

  setPromotionCodes(state, payload) {
    state.promotionCodes = payload;
  },

  setPrefixPromotion(state, payload) {
    state.prefixPromotion = payload;
  },

  setCampaignCombinations(state, payload) {
    state.campaignCombinations = payload;
  },

  setDateRange(state, payload) {
    state.dateRange = payload;
  },

  setOrderBy(state, payload) {
    state.orderBy = payload;
  },

  setProductType(state, payload) {
    state.productType = payload;
  },

  setActiveTab(state, payload) {
    state.activeTab = payload;
  },

  setSearchInput(state, payload) {
    state.searchInput = payload;
  },
  setRuleEngineOption(state, payload) {
    state.ruleEngineOption = payload;
  },
};

export default mutations;
